import NavBar from "./NavBar";
import "./Help.css";
import Footer from "./Footer";
const Help = () => {
  return (
    <>
      <NavBar />
      <section className="bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="card card-style1 border-0">
                <div className="card-body p-4 p-md-5 p-xl-6">
                  <div className="text-center mb-2-3 mb-lg-6">
                    <span className="section-title text-primary">FAQ's</span>
                    <h2 className="h1 mb-0 text-secondary">
                      Frequently Asked Questions
                    </h2>
                  </div>
                  <div id="accordion" className="accordion-style">
                    <div className="card mb-3">
                      <div className="card-header" id="headingOne">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            <span className="text-theme-secondary me-2">
                              Q.
                            </span>{" "}
                            How to create an Event?
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseOne"
                        className="collapse show"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordion"
                      >
                        <div className="card-body">
                          <ul className="help-topics-list">
                            <li>Click Events at the bottom menu</li>
                            <li>
                              Click{" "}
                              <img
                                className="help-icons-big"
                                src="/icons/plus.png"
                                alt="plus"
                              />{" "}
                              icon
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="card mb-3">
                      <div className="card-header" id="headingTwo">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            <span className="text-theme-secondary me-2">
                              Q.
                            </span>{" "}
                            How to edit an Event?
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseTwo"
                        className="collapse"
                        aria-labelledby="headingTwo"
                        data-bs-parent="#accordion"
                      >
                        <div className="card-body">
                          <ul className="help-topics-list">
                            <li>Click Events at the bottom menu</li>
                            <li>
                              In the Event card click{" "}
                              <img
                                className="help-icons"
                                src="/icons/edit.png"
                                alt="edit"
                              />{" "}
                              icon
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="card mb-3">
                      <div className="card-header" id="headingThree">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            <span className="text-theme-secondary me-2">
                              Q.
                            </span>{" "}
                            How to create an Event task?
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseThree"
                        className="collapse"
                        aria-labelledby="headingThree"
                        data-bs-parent="#accordion"
                      >
                        <div className="card-body">
                          <ul className="help-topics-list">
                            <li>Click Events at the bottom menu</li>
                            <li>
                              In the Event card click{" "}
                              <img
                                className="help-icons"
                                src="/icons/add.png"
                                alt="add"
                              />{" "}
                              icon
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="card mb-3">
                      <div className="card-header" id="headingFour">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFour"
                            aria-expanded="false"
                            aria-controls="collapseFour"
                          >
                            <span className="text-theme-secondary me-2">
                              Q.
                            </span>{" "}
                            How do I invite guests?
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseFour"
                        className="collapse"
                        aria-labelledby="headingFour"
                        data-bs-parent="#accordion"
                      >
                        <div className="card-body">
                          <ul className="help-topics-list">
                            <li>Click Events at the bottom menu</li>
                            <li>
                              In the Event card click{" "}
                              <img
                                className="help-icons-big"
                                src="/icons/invite.png"
                                alt="invite"
                              />{" "}
                              icon
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header" id="headingFive">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFive"
                            aria-expanded="false"
                            aria-controls="collapseFive"
                          >
                            <span className="text-theme-secondary me-2">
                              Q.
                            </span>{" "}
                            How do I send reminder to all invitees?
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseFive"
                        className="collapse"
                        aria-labelledby="headingFive"
                        data-bs-parent="#accordion"
                      >
                        <div className="card-body">
                          <ul className="help-topics-list">
                            <li>Click Events at the bottom menu</li>
                            <li>Click the event card to open the event</li>
                            <li>
                              Click{" "}
                              <img
                                className="help-icons"
                                src="/icons/remind.png"
                                alt="remind"
                              />{" "}
                              to send reminders to all accepted and pending
                              acceptance invitees
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    {/* <-- card --> */}
                    <div className="card">
                      <div className="card-header" id="headingSix">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseSix"
                            aria-expanded="false"
                            aria-controls="collapseSix"
                          >
                            <span className="text-theme-secondary me-2">
                              Q.
                            </span>{" "}
                            How to assign an Event task?
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseSix"
                        className="collapse"
                        aria-labelledby="headingSix"
                        data-bs-parent="#accordion"
                      >
                        <div className="card-body">
                          <p className="text-start">
                            During the task creation process, you will be
                            presented with the choice of assigning it to the
                            invited users, or alternatively, you can leave it
                            open for the invitees to select themselves.{" "}
                          </p>
                          <p className="text-start">
                            If you have created the task(s) before inviting
                            users, you follow the below steps to assign the
                            task.
                          </p>
                          <ul className="help-topics-list">
                            <li>Click Events at the bottom menu</li>
                            <li>Click the event card to open the event</li>
                            <li>
                              Under the Tasks section, click more to open all
                              tasks
                            </li>
                            <li>
                              Click{" "}
                              <img
                                className="help-icons"
                                src="/icons/reassign.png"
                                alt="reassign"
                              />{" "}
                              and select the invited person to assign the task
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    {/* <-- card --> */}
                    <div className="card">
                      <div className="card-header" id="headingSeven">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseSeven"
                            aria-expanded="false"
                            aria-controls="collapseSeven"
                          >
                            <span className="text-theme-secondary me-2">
                              Q.
                            </span>{" "}
                            How to remove invitee?
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseSeven"
                        className="collapse"
                        aria-labelledby="headingSeven"
                        data-bs-parent="#accordion"
                      >
                        <div className="card-body">
                          <ul className="help-topics-list">
                            <li>Click Events at the bottom menu</li>
                            <li>Click the event card to open the event</li>
                            <li>
                              Under the Invitees section, click more to open all
                              invited guests
                            </li>
                            <li>
                              Click{" "}
                              <img
                                className="help-icons-big"
                                src="/icons/remove.png"
                                alt="remove"
                              />{" "}
                              to remove the invite
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    {/* <-- card --> */}
                    <div className="card">
                      <div className="card-header" id="headingEight">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseEight"
                            aria-expanded="false"
                            aria-controls="collapseEight"
                          >
                            <span className="text-theme-secondary me-2">
                              Q.
                            </span>{" "}
                            How do I send reminder to individual invitee?
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseEight"
                        className="collapse"
                        aria-labelledby="headingEight"
                        data-bs-parent="#accordion"
                      >
                        <div className="card-body">
                          <ul className="help-topics-list">
                            <li>Click Events at the bottom menu</li>
                            <li>Click the event card to open the event</li>
                            <li>
                              Under the Invitees section, click more to open all
                              invited guests
                            </li>
                            <li>
                              Click{" "}
                              <img
                                className="help-icons"
                                src="/icons/remind.png"
                                alt="remind"
                              />{" "}
                              to send reminder to that invitee
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    {/* <-- card --> */}
                    <div className="card">
                      <div className="card-header" id="headingNine">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseNine"
                            aria-expanded="false"
                            aria-controls="collapseNine"
                          >
                            <span className="text-theme-secondary me-2">
                              Q.
                            </span>{" "}
                            How to create a personal task?
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseNine"
                        className="collapse"
                        aria-labelledby="headingNine"
                        data-bs-parent="#accordion"
                      >
                        <div className="card-body">
                          <ul className="help-topics-list">
                            <li>Click Task at the main menu</li>
                            <li>
                              Click{" "}
                              <img
                                className="help-icons-big"
                                src="/icons/plus.png"
                                alt="plus"
                              />{" "}
                              icon
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    {/* <-- card --> */}
                    <div className="card">
                      <div className="card-header" id="headingTen">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTen"
                            aria-expanded="false"
                            aria-controls="collapseTen"
                          >
                            <span className="text-theme-secondary me-2">
                              Q.
                            </span>{" "}
                            How do I change my password?
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseTen"
                        className="collapse"
                        aria-labelledby="headingTen"
                        data-bs-parent="#accordion"
                      >
                        <div className="card-body">
                          <ul className="help-topics-list">
                            <li>Settings</li>
                            <li>Click change password</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};
export default Help;
